class BannerMessageController {
  constructor(bannerMessageService) {
    this.message = null;
    this.bannerMessageService = bannerMessageService;
    this.getMessage();
  }

  getMessage() {
    this.bannerMessageService.getMessage()
      .then(this.onGetMessageSuccess.bind(this), this.onGetMessageFailure.bind(this));
  }

  onGetMessageSuccess(successResponse) {
    if (successResponse &&  successResponse.data && successResponse.data.toString().length > 5) {
      this.message = successResponse.data;
    }
  }

  onGetMessageFailure() {
    this.message = null;
  }
}

BannerMessageController.$inject = ['bannerMessageService'];

export default BannerMessageController;



// WEBPACK FOOTER //
// ./app/common/bannerMessage/bannerMessage.controller.js